<template lang="pug">
.pt-4.pb-16(v-if="data")
  v-tabs(
    height="80",
    grow,
    dark,
    background-color="primary",
    v-model="currentTabAlias"
  )
    v-tab(
      v-for="{ key, name, alias, activeClass } in tabs",
      :key="key",
      :to="alias",
      :active-class="activeClass"
    ) {{ name }}
  transition(name="fade", mode="out-in", appear)
    router-view(name="tab", :key="$route.path", @goto="goto")
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "employer-case",

  props: {
    tab: {
      type: [String, Number],
      required: false,
      default: "Overview",
    },
  },

  data: () => ({
    currentTabAlias: null,
    tabs: [
      "Overview",
      "Guide",
      "Case profile",
      "Candidate",
      "Documents",
      "Online application",
    ].map((name, i) => ({
      key: "tab:" + i,
      name,
      alias: name.toLowerCase().replace(" ", "_"),
      activeClass: "cyan darken-2",
    })),
  }),

  computed: {
    ...mapGetters({
      data: "usercase/currentUsercase",
    }),
  },

  methods: {
    goto(i) {
      const ID = this.$route.params.case_id;
      const alias = this.tabs[i].alias;
      const path = `/cases/${ID}/sponsorship/${alias}`;
      this.$router.push(path);
    },

    initHotjar() {
      (function (h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        h._hjSettings = { hjid: 2217198, hjsv: 6 };
        a = o.getElementsByTagName("head")[0];
        r = o.createElement("script");
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
    },
  },

  mounted() {
    this.initHotjar();
  },
};
</script>